import initialState from './initialState';
import {
  FETCH_HOMOLOGATION_SEMI_TRAILER_INIT,
  FETCH_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  FETCH_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  SAVE_HOMOLOGATION_SEMI_TRAILER_INIT,
  SAVE_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  SAVE_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  RESET_HOMOLOGATION_SEMI_TRAILER,
  FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_INIT,
  FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_INIT,
  FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS,
  FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE,
  RESET_MODAL_FILE,
  FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_SUCCESS,
  FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_FAILURE,
  FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_INIT
} from '../../actions/homologation_semi_trailer/types';

export default function homologationSemiTrailer(state = initialState, action) {
  switch (action.type) {
    case FETCH_HOMOLOGATION_SEMI_TRAILER_INIT:
      return{
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_HOMOLOGATION_SEMI_TRAILER_SUCCESS:
      return{
        ...state,
        datos: action.payload.data,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_HOMOLOGATION_SEMI_TRAILER_FAILURE:
      return{
        ...state,
        datos: {},
        error: action.payload,
        loading: false,
      };
    case FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_INIT:
      return{
        ...state,
        error: null,
      };
    case FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_SUCCESS:
      return{
        ...state,
        datos: action.payload.data,
        error: null,
        status: action.payload.status
      };
    case FETCH_HOMOLOGATION_SEMI_TRAILER_NO_LOADING_FAILURE:
      return{
        ...state,
        status: 500
      };
    case SAVE_HOMOLOGATION_SEMI_TRAILER_INIT:
      return{
        ...state,
        loadingSave: true,
        errorSave: null,
      };
    case SAVE_HOMOLOGATION_SEMI_TRAILER_SUCCESS:
      return{
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false, 
        statusSave: action.payload.status
      };
    case SAVE_HOMOLOGATION_SEMI_TRAILER_FAILURE:
      return{
        ...state,
        loadingSave: false,
        status: 500
      };
    case FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_INIT:
      return{
        ...state,
        loadingFile: true,
        error: null,
      };
    case FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS:
      return{
        ...state,
        datosFile: action.payload.data,
        error: null,
        loadingFile: false,
        statusFile: action.payload.status
      };
    case FETCH_DOWNLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE:
      return{
        ...state,
        loadingFile: false,
        status: 500
      };
    case FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_INIT:
      return{
        ...state,
        loadingFile: true,
        error: null,
      };
    case FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_SUCCESS:
      return{
        ...state,
        datosFile: action.payload.data,
        error: null,
        loadingFile: false,
        statusFile: action.payload.status
      };
    case FETCH_UPLOAD_HOMOLOGATION_SEMI_TRAILER_FAILURE:
      return{
        ...state,
        loadingFile: false,
        status: 500
      };
    case RESET_HOMOLOGATION_SEMI_TRAILER:
      return{
        ...state,
        datos: {},
        loading: true,
        error: null,
        status: null,
        loadingSave: false,
        statusSave: null, 
        dataSave: {},
        loadingFile: false,
        statusFile: null, 
        datosFile: {}
      };
    case RESET_MODAL_FILE:
      return{
        ...state,
        loadingFile: false,
        statusFile: null, 
        datosFile: {}
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/homologation_semi_trailer/index.js